import {Spacer} from '@repo/ui/spacer';

interface EditorErrorProps {
  error: string | null;
}

export function EditorError({error}: EditorErrorProps) {
  if (!error) return null;
  return (
    <>
      <Spacer size='xs' />
      <div className='px-3 py-2 rounded text-sm text-red-700 bg-red-50 border border-red-200'>
        {error}
      </div>
    </>
  );
}
